import { render, staticRenderFns } from "./Localize.vue?vue&type=template&id=46bc1e18&scoped=true"
import script from "./Localize.vue?vue&type=script&lang=js"
export * from "./Localize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bc1e18",
  null
  
)

export default component.exports